(function ($) {
    function ProductOverviewAccordion(element) {
        const $container = $(element);
        if (!$container.length) return;

        const $markers = $container.find('.product-overview__marker');
        const $featureItems = $container.find('.product-overview__feature-item');
        const $featureContents = $container.find('.product-overview__feature-content');
        const $featuresListContainer = $container.find('.product-overview__features');

        const setInitialStates = () => {
            $featureContents.css('max-height', '0px');
            $featureItems.removeClass('is-active');
            $markers.removeClass('is-active');
            $featureItems.each((_, item) => {
                $(item).find('.product-overview__feature-toggle').text('+');
            });
        };

        const toggleFeature = (featureNumber) => {
            const $marker = $container.find(`.product-overview__marker[data-feature="${featureNumber}"]`);
            const $item = $container.find(`.product-overview__feature-item[data-feature="${featureNumber}"]`);
            if (!$marker.length || !$item.length) return;

            const $content = $item.find('.product-overview__feature-content');
            if (!$content.length) return;

            const isActive = $item.hasClass('is-active');

            if (!isActive) {
                $featureItems.filter('.is-active').not($item).each((_, el) => {
                    const $activeItem = $(el);
                    const activeFeatureNum = $activeItem.data('feature');
                    $container.find(`.product-overview__marker[data-feature="${activeFeatureNum}"]`).removeClass('is-active');
                    $activeItem.find('.product-overview__feature-content').css('max-height', '0px');
                    $activeItem.find('.product-overview__feature-toggle').text('+');
                    $activeItem.removeClass('is-active');
                });
            }

            $item.toggleClass('is-active');
            $marker.toggleClass('is-active');
            const $toggleButton = $item.find('.product-overview__feature-toggle');

            if ($item.hasClass('is-active')) {
                $content.css('max-height', $content[0].scrollHeight + 'px');
                $toggleButton.text('–');
            } else {
                $content.css('max-height', '0px');
                $toggleButton.text('+');
            }
        };

        $markers.on('click', (e) => {
            toggleFeature($(e.currentTarget).data('feature'));
        });

        if ($featuresListContainer.length) {
            $featuresListContainer.on('click', '.product-overview__feature-header', (e) => {
                const $item = $(e.currentTarget).closest('.product-overview__feature-item');
                if ($item.length && typeof $item.data('feature') !== 'undefined') {
                    toggleFeature($item.data('feature'));
                }
            });
        }

        setInitialStates();
    }

    $(document).ready(() => {
        $('.product-overview').each(function() {
            ProductOverviewAccordion(this);
        });
    });

})(jQuery);